export default __webpack_public_path__ + "static/media/guardianaction.acf39a87.png";